// Component
import { SisuCarousel } from './sisu-carousel.component'

export default SisuCarousel
